module.exports = new __parcel__URL__("YIMBY.56a157ba.svg").toString();